import { Button, ButtonProps } from '@mui/material'

import AppleMark from './AppleMark'

// ----------------------------------------------------------------------
// Continue with Apple, drawn the way Apple's guidelines draw its sign-in
// button: black on a light page and white on a dark one, the label and the
// mark in the other, so the button is its own boundary in both. The colours
// are `appleButton` in the palette, from the tokens, so nothing here states
// one. The mark is as big as Google's G in the button beside it, and centred
// on its ink rather than its box, so the leaf does not drop the apple below
// the words.
// ----------------------------------------------------------------------

export default function AppleSignInButton({
  children = 'Continue with Apple',
  sx,
  ...other
}: Omit<ButtonProps, 'color' | 'variant' | 'startIcon'>) {
  return (
    <Button
      variant="contained"
      disableElevation
      startIcon={<AppleMark inherit />}
      sx={[
        {
          'bgcolor': 'appleButton.fill',
          'color': 'appleButton.text',
          '&:hover': { bgcolor: 'appleButton.pressed' },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      {children}
    </Button>
  )
}
